(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mambe-fundraiser-intro"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const link=event.target.closest('[data-mfr-register]');if(!link)return;const href=link.getAttribute('href');if(!href||!href.startsWith('#'))return;const target=document.getElementById(href.slice(1));if(!target)return;event.preventDefault();target.setAttribute('tabindex','-1');target.style.scrollMarginTop='120px';target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});target.focus({preventScroll:true});});

  } catch(e) { console.error(e); }
})();
})();
